var a={borderRadius:4};export{a as default};
//# sourceMappingURL=shape.js.map
